<template>
    <div class="row inxmail">
        <inxmail-form :aspData="aspData"></inxmail-form>
    </div>
</template>
<script>
import InxmailForm from './components/InxmailForm.vue';
export default{
    data() {
        return {
            content: 'Newsletter',
            aspData: null
        }
    },
    created() {
        this.aspData = this.$parent.$data;
    },
    components: {
            InxmailForm
    }
}
</script>
